import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@nesso/ui/primitives/alert-dialog';
import { Button } from '@nesso/ui/primitives/button';

type Props = {
    open: boolean;
    isPending: boolean;
    onRequestLink: () => void;
    onClose: () => void;
};

export function ProfileVerificationExpiredDialog({
    open,
    isPending,
    onRequestLink,
    onClose,
}: Props) {
    return (
        <AlertDialog open={open} onOpenChange={(next) => !next && onClose()}>
            <AlertDialogContent className="sm:max-w-lg">
                <AlertDialogHeader className="text-left">
                    <AlertDialogTitle>Email verification link expired</AlertDialogTitle>
                    <AlertDialogDescription>
                        Request a new link and complete the verification within the next 72 hours.
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    {/* Not AlertDialogAction: that closes on click, and this dialog has to stay up
                        until the resend resolves so the pending state is visible. */}
                    <Button onClick={onRequestLink} disabled={isPending}>
                        {isPending ? 'Sending…' : 'Request Verification Link'}
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
